import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import {
  FiIdCard,
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiCalendar,
} from "react-icons/fi";
function EditImpression() {
  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    //minWidth: "1em",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);
  const toggleIdentificationAccordion = () =>
    setIsIdentificationAccordionOpen((o) => !o);
  const [
    isRenseignementsJuridiquesAccordionOpen,
    setIsRenseignementsJuridiquesAccordionOpen,
  ] = useState(true);
  const toggleRenseignementsJuridiquesAccordion = () =>
    setIsRenseignementsJuridiquesAccordionOpen((o) => !o);
  const [isReductionDomComAccordionOpen, setIsReductionDomComAccordionOpen] =
    useState(true);
  const toggleReductionDomComAccordion = () =>
    setIsReductionDomComAccordionOpen((o) => !o);
  const [isComptabiliteAccordionOpen, setIsComptabiliteAccordionOpen] =
    useState(true);
  const toggleComptabiliteAccordion = () =>
    setIsComptabiliteAccordionOpen((o) => !o);
  const [isTranchesAccordionOpen, setIsTranchesAccordionOpen] = useState(true);
  const toggleTranchesAccordion = () => setIsTranchesAccordionOpen((o) => !o);
  const [
    isDonneesComptablesAccordionOpen,
    setIsDonneesComptablesAccordionOpen,
  ] = useState(true);
  const toggleDonneesComptablesAccordion = () =>
    setIsDonneesComptablesAccordionOpen((o) => !o);
  const [isPrestationsAccordionOpen, setIsPrestationsAccordionOpen] =
    useState(true);
  const togglePrestationsAccordion = () =>
    setIsPrestationsAccordionOpen((o) => !o);
  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
      marginTop: "-8px", // Au lieu de la valeur par défaut (8px)
      marginBottom: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "#fff", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [pmeData, setPmeData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const yesNoData = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const [selectedYesNo, setSelectedYesNo] = useState("");
  const renderYesNoOptions = () => {
    return [
      <option key="" value=""></option>,
      ...yesNoData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  const handleYesNoChange = (e) => {
    setSelectedYesNo(e.target.value);
  };
  /*************************   publipostage *******************************/
  const [publipostageData, setPublipostageData] = useState({ data: [] });
  const [selectedPublipostage, setSelectedPublipostage] = useState("");
  const handlePublipostageChange = (e) => {
    setSelectedPublipostage(e);
  };
  const getPublipostage = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/pmes/publipostages`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPublipostageData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPublipostageOptions = () => {
    return [
      {
        options: publipostageData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/pmes/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const pmeData = await response.json();
      setPmeData(pmeData);
      setSelectedSociete(pmeData?.detail_pme?.Identification?.["Sociéte"]);
      setSelectedNatureInvestissement(
        pmeData?.detail_pme?.Identification?.["Catégorie de PME"]
      );
      setSelectedProduit(pmeData?.detail_pme?.Identification?.["Produit"]);
      setSelectedStatut(pmeData?.detail_pme?.Identification?.["Statut"]);
      setSelectedPartenaire(
        pmeData?.detail_pme?.Identification?.["Direction SAS"]
      );
      setSelectedRcs(pmeData?.detail_pme?.Identification?.["RCS (siren)"]);
      setSelectedSiret(pmeData?.detail_pme?.Identification?.["Siret"]);
      setSelectedObjetSocial(
        pmeData?.detail_pme?.Identification?.["Objet social"]
      );
      setSelectedDateDeCrea(
        pmeData?.detail_pme?.["Renseignements juridiques"]?.["Date de création"]
      );
      setSelectedDateImmatricul(
        pmeData?.detail_pme?.["Renseignements juridiques"]?.[
          "Date immatriculation"
        ]
      );
      setSelectedCode(
        pmeData?.detail_pme?.["Renseignements juridiques"]?.["Code APE"]
      );
      setSelectedNbAction(
        pmeData?.detail_pme?.["Renseignements juridiques"]?.[
          "Nb actions fondateurs"
        ]
      );
      setSelectedValeur(
        pmeData?.detail_pme?.["Renseignements juridiques"]?.[
          "Valeur nominale (€)"
        ]
      );
      setSelectedNombreAct(
        pmeData?.detail_pme?.["Renseignements juridiques"]?.["Nombre d'actions"]
      );
      setSelectedCapitalSoc(
        pmeData?.detail_pme?.["Renseignements juridiques"]?.[
          "Capital social (€)"
        ]
      );
      setSelectedPourcRes(
        pmeData?.detail_pme?.["Réduction d'impôt (DOM COM)"]?.[
          "% Résultat affecté"
        ]
      );
      setSelectedDateoption(
        pmeData?.detail_pme?.["Réduction d'impôt (DOM COM)"]?.["Date option IR"]
      );
      setFormTranches(
        pmeData?.detail_pme?.["Augmentations de capital"]?.["Tranches"].data
      );
      setFormDonneesComptable(
        pmeData?.detail_pme?.["Données comptables"]?.["Données comptables"].data
      );
      setFormPrestation(
        pmeData?.detail_pme?.["Prestations externalisées"]?.["Prestations"].data
      );
      setSelectedService(
        pmeData?.detail_pme?.["Comptabilité"]?.["Service des impôts"]
      );
    } catch (error) {
      console.error(error);
    }
  };
  /*************************   Partenaire   *******************************/
  const [selectedPartenaire, setSelectedPartenaire] = useState("");
  const [partenaireData, setPartenaireData] = useState({ data: [] });
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/pmes/partenaires`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((partenaire) => {
          setPartenaireData(partenaire);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: partenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const renderPartenaireHmfOptions = () => {
    return [
      <option key="" value=""></option>,
      ...partenaireData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  /************************* Nature investissement *******************************/
  const [natureInvestissementData, setNatureInvestissementData] = useState({
    data: [],
  });
  const [selectedNatureInvestissement, setSelectedNatureInvestissement] =
    useState("");
  const handleNatureInvestissementChange = (e) => {
    setSelectedNatureInvestissement(e);
  };
  const getNatureInvest = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/pmes/natures_investissements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setNatureInvestissementData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderNatureInvestissementOptions = () => {
    return [
      {
        options: natureInvestissementData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END  *******************************/
  /*************************   Produits  *******************************/
  const [produitsData, setproduitsData] = useState({ data: [] });
  const [selectedProduit, setSelectedProduit] = useState("");
  const handleProduitChange = (e) => {
    setSelectedProduit(e);
  };
  const getProduit = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/pmes/produits`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setproduitsData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderProduitOptions = () => {
    return [
      {
        options: produitsData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END produits *******************************/
  /************************* STATUT PMES  *******************************/
  const [selectedStatut, setSelectedStatut] = useState("");
  const [statutData, setStatutData] = useState({ data: [] });
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };

  const getStatut = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/pmes/statut_pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setStatutData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END STATUT *******************************/
  /*************************   SOCIETE  *******************************/
  const [societe, setSocieteData] = useState({ data: [] });
  const [selectedSociete, setSelectedSociete] = useState("");
  const handleSocieteChange = (e) => {
    setSelectedSociete(e);
  };
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/pmes/societes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSocieteData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderSocieteOptions = () => {
    return [
      {
        options: societe.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END SOCIETE *******************************/
  /********************services_impots_entreprises */
  const [selectedService, setSelectedService] = useState("");
  const [serviceData, setServiceData] = useState({ data: [] });
  const handleServiceChange = (e) => {
    setSelectedService(e);
  };
  const getService = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/pmes/services_impots_entreprises`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((service) => {
          setServiceData(service);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderServiceOptions = () => {
    return [
      {
        options: serviceData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   Annee   *******************************/
  const [selectedAnnee, setSelectedAnnee] = useState("");
  const [anneeData, setAnneeData] = useState({ data: [] });
  const handleAnneeChange = (e) => {
    setSelectedAnnee(e);
  };
  const getAnnee = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/pmes/annees`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setAnneeData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderAnneeOptions = () => {
    return [
      <option key="" value=""></option>,
      ...anneeData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };

  /*************************   END ANNEE *******************************/
  //****SHOW */
  const [showField, setShowFied] = useState("");
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/pmes/show_fields?pme_id=${id}&natures_investissement_id=${
          selectedNatureInvestissement?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((reservation) => {
          setShowFied(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /*************************   Modele *******************************/
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };

  /*************************   END Modele  *******************************/
  /******************************* HMF Tranches *******************************************/
  const [formTranches, setFormTranches] = useState({});

  const onAddFormTranches = () => {
    const modifiedTranches = [...formTranches];
    modifiedTranches.push({
      index: modifiedTranches.length + 1,
      id: null,
      numero: null,
      nombre_actions: null,
      valeur_action: null,
      date_limite_resa: null,
      date_augmentation: null,
      finalisee: null,
    });
    setFormTranches(modifiedTranches);
  };

  const onDeleteFormTranches = (id) => {
    var modifiedTranches = [...formTranches];
    modifiedTranches = modifiedTranches.filter((x) => x["index"] !== id);
    setFormTranches(modifiedTranches);
  };
  const handleInputChange = (index, field, value) => {
    const modifiedTranches = formTranches.map((tanche) => {
      if (tanche.index === index) {
        return {
          ...tanche,
          [field]: value,
        };
      }
      return tanche;
    });

    setFormTranches(modifiedTranches);
  };
  /******************************* END HMF Tranches *******************************************/
  /******************************* HMF DonneesComptable *******************************************/
  const [formDonneesComptable, setFormDonneesComptable] = useState({});

  const onAddFormDonneesComptable = () => {
    const modifiedDonneesComptable = [...formDonneesComptable];
    console.log(modifiedDonneesComptable);
    modifiedDonneesComptable.push({
      index: modifiedDonneesComptable.length + 1,
      id: null,
      annee_id: null,
      montant: null,
    });
    console.log(modifiedDonneesComptable);
    setFormDonneesComptable(modifiedDonneesComptable);
  };

  const onDeleteFormDonneesComptable = (id) => {
    var modifiedDonneesComptable = [...formDonneesComptable];
    modifiedDonneesComptable = modifiedDonneesComptable.filter(
      (x) => x["index"] !== id
    );
    setFormDonneesComptable(modifiedDonneesComptable);
  };
  const handleInputComptableChange = (index, field, value) => {
    const modifiedDonneesComptable = formDonneesComptable.map(
      (donnesComptable) => {
        if (donnesComptable.index === index) {
          return {
            ...donnesComptable,
            [field]: value,
          };
        }
        return donnesComptable;
      }
    );

    setFormDonneesComptable(modifiedDonneesComptable);
    console.log(modifiedDonneesComptable);
  };
  /******************************* END HMF DonneesComptable *******************************************/
  /******************************* HMF Prestation *******************************************/
  const [formPrestation, setFormPrestation] = useState({});

  const onAddFormPrestation = () => {
    const modifiedPrestation = [...formPrestation];
    console.log(modifiedPrestation);
    modifiedPrestation.push({
      index: modifiedPrestation.length + 1,
      id: null,
      partenaire_id: null,
      montant: null,
    });
    console.log(modifiedPrestation);
    setFormPrestation(modifiedPrestation);
  };

  const onDeleteFormPrestation = (id) => {
    var modifiedPrestation = [...formPrestation];
    modifiedPrestation = modifiedPrestation.filter((x) => x["index"] !== id);
    setFormPrestation(modifiedPrestation);
  };
  const handleInputPrestationChange = (index, field, value) => {
    const modifiedPrestation = formPrestation.map((donnesPrestation) => {
      if (donnesPrestation.index === index) {
        return {
          ...donnesPrestation,
          [field]: value,
        };
      }
      return donnesPrestation;
    });

    setFormPrestation(modifiedPrestation);
  };
  /******************************* END HMF Prestation *******************************************/
  const [selectedCode, setSelectedCode] = useState("");
  const [selectedNbAction, setSelectedNbAction] = useState("");
  const [selectedValeur, setSelectedValeur] = useState("");
  const [selectedNombreAct, setSelectedNombreAct] = useState("");
  const [selectedCapitalSoc, setSelectedCapitalSoc] = useState("");
  const [selectedPourcRes, setSelectedPourcRes] = useState("");
  const [selectedDateoption, setSelectedDateoption] = useState("");

  const [selectedChamps4, setSelectedChamps4] = useState("");
  const [selectedChamps5, setSelectedChamps5] = useState("");
  const [selectedChamps6, setSelectedChamps6] = useState("");

  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };

  const handleNbActionChange = (e) => {
    setSelectedNbAction(e.target.value);
  };

  const handleValeurChange = (e) => {
    setSelectedValeur(e.target.value);
    setSelectedCapitalSoc(
      parseFloat(e.target.value) * parseFloat(selectedNombreAct)
    );
    document.getElementById("capital_social").value =
      parseFloat(e.target.value) * parseFloat(selectedNombreAct);
  };
  const handleNombreActChange = (e) => {
    setSelectedNombreAct(e.target.value);
  };
  const handlePourcResChange = (e) => {
    setSelectedPourcRes(e.target.value);
  };

  const handleCapitalSocChange = (e) => {
    setSelectedCapitalSoc(e.target.value);
  };

  const handleChamps4Change = (e) => {
    setSelectedChamps4(e.target.value);
  };

  const handleChamps5Change = (e) => {
    setSelectedChamps5(e.target.value);
  };

  const handleChamps6Change = (e) => {
    setSelectedChamps6(e.target.value);
  };

  /*************************   END date d'engagement   *******************************/
  /*************************   Complément  *******************************/
  const [selectedFichier, setSelectedFichier] = useState("");

  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      const reader = new FileReader();

      reader.onloadend = function () {
        // Convertir les données du fichier en base64
        const fileData = reader.result.split(",")[1]; // Récupérer la partie base64 des données

        // Créer un objet JSON contenant les données du fichier
        const fileObject = {
          name: newFile.name, // Nom du fichier
          type: newFile.type, // Type MIME du fichier
          size: newFile.size, // Taille du fichier
          data: fileData, // Données du fichier encodées en base64
        };
        setSelectedFichier(fileObject);
      };
      reader.readAsDataURL(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  /************************* END Complément   *******************************/

  /******************************* Date de début *******************************************/
  const [selectedDateDeCrea, setSelectedDateDeCrea] = useState("");

  /******************************* END date de début *******************************************/
  /******************************* date de fin *******************************************/
  const [selectedDateImmatricul, setSelectedDateImmatricul] = useState("");
  /******************************* Valide *******************************************/
  const [selectedValide, setSelectedValide] = useState("");
  const handleValideChange = (e) => {
    setSelectedValide(e);
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  /******************************* END Valide *******************************************/
  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };

  /******************************* END Mode de règlement *******************************************/
  /******************************* RCS *******************************************/
  const [selectedRcs, setSelectedRcs] = useState("");
  const handleRcsChange = (e) => {
    setSelectedRcs(e.target.value);
  };
  /******************************* END RCS *******************************************/
  /******************************* Siret *******************************************/
  const [selectedSiret, setSelectedSiret] = useState("");
  const handleSiretChange = (e) => {
    setSelectedSiret(e.target.value);
  };
  /******************************* END Siret *******************************************/
  /******************************* Objet Social *******************************************/
  const [selectedObjetSocial, setSelectedObjetSocial] = useState("");
  const handleObjetSocialChange = (e) => {
    setSelectedObjetSocial(e.target.value);
  };
  /******************************* END Objet Social *******************************************/

  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);

    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedSociete === null ||
      selectedStatut === null ||
      selectedValeur === ""
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/pmes/${id}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              pme: {
                societe_id: selectedSociete.value || "",
                natures_investissement_id:
                  selectedNatureInvestissement.value || "",
                date_de_creation: selectedDateDeCrea,
                capital_social: selectedCapitalSoc,
                nombre_dactions: selectedNbAction,
                valeur_nominale: selectedValeur,
                statut_pme_id: selectedStatut?.value || "",
                pourc_resultat_affecte: selectedPourcRes,
                code_ape: selectedCode,
                siret: selectedSiret,
                date_immatriculation: selectedDateImmatricul,
                date_option_ir: selectedDateoption,
                rcs: selectedRcs,
                partenaire_id: selectedPartenaire.value || "",
                objet_social: selectedObjetSocial,
                produit_id: selectedProduit.value || "",
                services_impots_entreprise_id: selectedService.value || "",
                id: id,
              },
              pme_hmf_tranches: formTranches.map((obj) => {
                // on retire le champs index
                delete obj.index;
                return obj;
              }),
              pme_hmf_resultats: formDonneesComptable.map((obj) => {
                delete obj.index;
                return obj;
              }),
              pme_hmf_prestations_externes: formPrestation.map((obj) => {
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.pme_validation) {
            const errors = responseData?.pme_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (!loading) {
      getAnnee();
      getProduit();
      getNatureInvest();
      getService();
      getSociete();
      getStatut();
      getPartenaire();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getShow();
    }
  }, [loading, selectedNatureInvestissement]);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "PME | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Pme
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/pmes/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          PME
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          pmeData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                {pmeData?.detail_pme?.Identification && (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleIdentificationAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Identification
                                        </span>
                                      </div>
                                      {isIdentificationAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse
                                      isOpen={isIdentificationAccordionOpen}
                                    >
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            pmeData?.detail_pme?.Identification
                                          ).map(([key, value], index) => (
                                            <React.Fragment key={index}>
                                              {key === "Sociéte" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid #dc3545",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Sociéte
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedSociete?.label ==
                                                          null
                                                            ? null
                                                            : selectedSociete
                                                        }
                                                        onChange={
                                                          handleSocieteChange
                                                        }
                                                        options={renderSocieteOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedSociete ===
                                                            null
                                                        )}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner une société..."
                                                      />
                                                      {selectedSociete ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Sociéte ne peut pas
                                                          être vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {key === "Catégorie de PME" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Catégorie de PME
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        isDisabled={true}
                                                        value={
                                                          selectedNatureInvestissement?.label ==
                                                          null
                                                            ? null
                                                            : selectedNatureInvestissement
                                                        }
                                                        onChange={
                                                          handleNatureInvestissementChange
                                                        }
                                                        options={renderNatureInvestissementOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {key === "Produit" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Produit
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedProduit?.label ==
                                                          null
                                                            ? null
                                                            : selectedProduit
                                                        }
                                                        onChange={
                                                          handleProduitChange
                                                        }
                                                        options={renderProduitOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner un produit..."
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {key === "Statut" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid #dc3545",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Statut
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedStatut?.label ==
                                                          null
                                                            ? null
                                                            : selectedStatut
                                                        }
                                                        onChange={
                                                          handleStatutChange
                                                        }
                                                        options={renderStatutOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(
                                                          selectedStatut ===
                                                            null
                                                        )}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner un statut..."
                                                      />
                                                      {selectedStatut ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Statut ne peut pas
                                                          être vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {key === "Direction SAS" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Direction SAS
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedPartenaire?.label ==
                                                          null
                                                            ? null
                                                            : selectedPartenaire
                                                        }
                                                        onChange={
                                                          handlePartenaireChange
                                                        }
                                                        options={renderPartenaireOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner une direction..."
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {key === "RCS (siren)" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          RCS (siren)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        type="text"
                                                        value={selectedRcs}
                                                        onChange={
                                                          handleRcsChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {key === "Siret" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Siret
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        type="text"
                                                        value={selectedSiret}
                                                        onChange={
                                                          handleSiretChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {key === "Objet social" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-start g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Objet social
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <textarea
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        rows={3}
                                                        value={
                                                          selectedObjetSocial
                                                        }
                                                        onChange={
                                                          handleObjetSocialChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}
                                            </React.Fragment>
                                          ))}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                )}
                              </Col>

                              <Col sm="6">
                                {pmeData?.detail_pme?.[
                                  "Renseignements juridiques"
                                ] && (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={
                                        toggleRenseignementsJuridiquesAccordion
                                      }
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Renseignements juridiques
                                        </span>
                                      </div>
                                      {isRenseignementsJuridiquesAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse
                                      isOpen={
                                        isRenseignementsJuridiquesAccordionOpen
                                      }
                                    >
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            pmeData?.detail_pme?.[
                                              "Renseignements juridiques"
                                            ]
                                          ).map(([key, value], index) => (
                                            <React.Fragment key={index}>
                                              {/* Date de création */}
                                              {key === "Date de création" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Date de création
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <div className="input-wrapper position-relative">
                                                        <InputMask
                                                          mask="99/99/9999"
                                                          value={
                                                            selectedDateDeCrea
                                                          }
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          onChange={(
                                                            dateString
                                                          ) =>
                                                            setSelectedDateDeCrea(
                                                              dateString.target
                                                                .value
                                                            )
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                          }}
                                                          onFocus={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#ffffff";
                                                            e.currentTarget.style.boxShadow =
                                                              "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                          }}
                                                          onBlur={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#f8f9fa";
                                                            e.currentTarget.style.boxShadow =
                                                              "none";
                                                          }}
                                                        />
                                                        <FiCalendar
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Date immatriculation */}
                                              {key ===
                                                "Date immatriculation" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Date immatriculation
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <div className="input-wrapper position-relative">
                                                        <InputMask
                                                          mask="99/99/9999"
                                                          value={
                                                            selectedDateImmatricul
                                                          }
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          onChange={(
                                                            dateString
                                                          ) =>
                                                            setSelectedDateImmatricul(
                                                              dateString.target
                                                                .value
                                                            )
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                          }}
                                                          onFocus={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#ffffff";
                                                            e.currentTarget.style.boxShadow =
                                                              "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                          }}
                                                          onBlur={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#f8f9fa";
                                                            e.currentTarget.style.boxShadow =
                                                              "none";
                                                          }}
                                                        />
                                                        <FiCalendar
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Code APE */}
                                              {key === "Code APE" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Code APE
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        defaultValue={
                                                          selectedCode
                                                        }
                                                        required
                                                        onChange={
                                                          handleCodeChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Nb actions fondateurs */}
                                              {key ===
                                                "Nb actions fondateurs" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Nb actions fondateurs
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        defaultValue={
                                                          selectedNbAction
                                                        }
                                                        required
                                                        onChange={
                                                          handleNbActionChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Valeur nominale (€) */}
                                              {key ===
                                                "Valeur nominale (€)" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid #dc3545",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Valeur nominale (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        defaultValue={
                                                          selectedValeur
                                                        }
                                                        required
                                                        onChange={
                                                          handleValeurChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                      {selectedValeur ===
                                                        "" && (
                                                        <div
                                                          className="mt-1"
                                                          style={{
                                                            color: "red",
                                                            whiteSpace:
                                                              "nowrap",
                                                            fontSize: 12,
                                                          }}
                                                        >
                                                          Valeur nominale (€) ne
                                                          peut pas être vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Nombre d'actions */}
                                              {key === "Nombre d'actions" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Nombre d&apos;actions
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        disabled
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        defaultValue={
                                                          selectedNombreAct
                                                        }
                                                        onChange={
                                                          handleNombreActChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                          textAlign: "right",
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {/* Capital social (€) */}
                                              {key === "Capital social (€)" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Capital social (€)
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        id="capital_social"
                                                        disabled
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        defaultValue={
                                                          selectedCapitalSoc
                                                        }
                                                        onChange={
                                                          handleCapitalSocChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                          textAlign: "right",
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}
                                            </React.Fragment>
                                          ))}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                )}
                              </Col>

                              <Col sm="6">
                                {pmeData?.detail_pme?.[
                                  "Réduction d'impôt (DOM COM)"
                                ] && (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En‑tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleReductionDomComAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Réduction d&apos;impôt (DOM COM)
                                        </span>
                                      </div>
                                      {isReductionDomComAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse
                                      isOpen={isReductionDomComAccordionOpen}
                                    >
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            pmeData?.detail_pme?.[
                                              "Réduction d'impôt (DOM COM)"
                                            ]
                                          ).map(([key, value], index) => (
                                            <React.Fragment key={index}>
                                              {key === "% Résultat affecté" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          % Résultat affecté
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        defaultValue={
                                                          selectedPourcRes
                                                        }
                                                        required
                                                        onChange={
                                                          handlePourcResChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}

                                              {key === "Date option IR" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Date option IR
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <div className="input-wrapper position-relative">
                                                        <InputMask
                                                          mask="99/99/9999"
                                                          value={
                                                            selectedDateoption
                                                          }
                                                          className="form-control form-control-sm shadow-sm border-0"
                                                          onChange={(
                                                            dateString
                                                          ) =>
                                                            setSelectedDateoption(
                                                              dateString.target
                                                                .value
                                                            )
                                                          }
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            borderRadius: "6px",
                                                            padding:
                                                              "0.375rem 2rem 0.375rem 0.5rem",
                                                            height: "32px",
                                                            transition:
                                                              "all 0.2s ease",
                                                          }}
                                                          onFocus={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#ffffff";
                                                            e.currentTarget.style.boxShadow =
                                                              "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                          }}
                                                          onBlur={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                              "#f8f9fa";
                                                            e.currentTarget.style.boxShadow =
                                                              "none";
                                                          }}
                                                        />
                                                        <FiCalendar
                                                          size={12}
                                                          className="position-absolute text-muted"
                                                          style={{
                                                            right: "8px",
                                                            top: "50%",
                                                            transform:
                                                              "translateY(-50%)",
                                                            pointerEvents:
                                                              "none",
                                                            opacity: 0.9,
                                                          }}
                                                        />
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}
                                            </React.Fragment>
                                          ))}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                )}
                              </Col>

                              <Col sm="12">
                                {pmeData?.detail_pme?.[
                                  "Augmentations de capital"
                                ] ? (
                                  <>
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En‑tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleTranchesAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Tranches
                                          </span>
                                        </div>
                                        {isTranchesAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isTranchesAccordionOpen}
                                      >
                                        <CardBody className="p-2">
                                          <Col sm="12">
                                            <div className="table-responsive">
                                              <table
                                                className="table table-bordered rounded-3 overflow-hidden"
                                                style={{
                                                  borderCollapse: "collapse",
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {pmeData?.detail_pme?.[
                                                      "Augmentations de capital"
                                                    ]?.["Tranches"].header.map(
                                                      (columnName, index) => (
                                                        <th
                                                          className="text-nowrap"
                                                          style={tableaustyles}
                                                          key={index}
                                                        >
                                                          {columnName}
                                                        </th>
                                                      )
                                                    )}
                                                    <th
                                                      className="text-nowrap"
                                                      style={{
                                                        background: "#555B21",
                                                        color: "white",
                                                        paddingTop: "5px",
                                                        paddingBottom: "5px",
                                                        width: "1%",
                                                      }}
                                                      key="Del"
                                                    ></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {formTranches.map(
                                                    (rowData) => (
                                                      <tr key={rowData.index}>
                                                        {Object.entries(
                                                          rowData
                                                        ).map(([key, value]) =>
                                                          key !== "id" &&
                                                          key !== "index" ? (
                                                            <td key={key}>
                                                              {key ===
                                                              "finalisee" ? (
                                                                <select
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name="finalisee"
                                                                  className="form-control form-control-sm"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                >
                                                                  {renderYesNoOptions()}
                                                                </select>
                                                              ) : key ===
                                                                  "date_augmentation" ||
                                                                key ===
                                                                  "date_limite_resa" ? (
                                                                <InputMask
                                                                  mask="99/99/9999"
                                                                  value={value}
                                                                  name={key}
                                                                  className="form-control form-control-sm"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : key ===
                                                                  "numero" ||
                                                                key ===
                                                                  "nombre_actions" ||
                                                                key ===
                                                                  "valeur_action" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : null}
                                                            </td>
                                                          ) : null
                                                        )}
                                                        <td
                                                          style={{
                                                            width: "1%",
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          <i
                                                            className="bx bx-trash"
                                                            style={{
                                                              fontSize: "20px",
                                                              paddingTop: "5px",
                                                              textAlign:
                                                                "center",
                                                              verticalAlign:
                                                                "middle",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              onDeleteFormTranches(
                                                                rowData.index
                                                              )
                                                            }
                                                          ></i>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                  <tr>
                                                    <td colSpan="9">
                                                      <button
                                                        type="button"
                                                        style={tableaustyles}
                                                        className="btn btn-info mt-3 mt-lg-0"
                                                        onClick={
                                                          onAddFormTranches
                                                        }
                                                      >
                                                        Ajouter
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </Col>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                              <Col sm="6">
                                {pmeData?.detail_pme?.["Données comptables"] ? (
                                  <>
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En‑tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={
                                          toggleDonneesComptablesAccordion
                                        }
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Données comptables
                                          </span>
                                        </div>
                                        {isDonneesComptablesAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={
                                          isDonneesComptablesAccordionOpen
                                        }
                                      >
                                        <CardBody className="p-2">
                                          <Col sm="12">
                                            <div className="table-responsive">
                                              <table
                                                className="table table-bordered rounded-3 overflow-hidden"
                                                style={{
                                                  borderCollapse: "collapse",
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {pmeData?.detail_pme?.[
                                                      "Données comptables"
                                                    ]?.[
                                                      "Données comptables"
                                                    ].header.map(
                                                      (columnName, index) => (
                                                        <th
                                                          className="text-nowrap"
                                                          style={tableaustyles}
                                                          key={index}
                                                        >
                                                          {columnName}
                                                        </th>
                                                      )
                                                    )}
                                                    <th
                                                      className="text-nowrap"
                                                      style={{
                                                        background: "#555B21",
                                                        color: "white",
                                                        paddingTop: "5px",
                                                        paddingBottom: "5px",
                                                        width: "1%",
                                                      }}
                                                      key="Del"
                                                    ></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {formDonneesComptable.map(
                                                    (rowData) => (
                                                      <tr key={rowData.index}>
                                                        {Object.entries(
                                                          rowData
                                                        ).map(([key, value]) =>
                                                          key !== "id" &&
                                                          key !== "index" ? (
                                                            <td key={key}>
                                                              {key ===
                                                              "annee_id" ? (
                                                                <select
                                                                  value={
                                                                    value?.value
                                                                  }
                                                                  name="annee_id"
                                                                  className="form-control form-control-sm"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputComptableChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                >
                                                                  {renderAnneeOptions()}
                                                                </select>
                                                              ) : key ===
                                                                "montant" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputComptableChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                <span>
                                                                  {value}
                                                                </span>
                                                              )}
                                                            </td>
                                                          ) : (
                                                            <td
                                                              className="d-none"
                                                              key={key}
                                                            >
                                                              <input
                                                                type="hidden"
                                                                value={value}
                                                                readOnly
                                                              />
                                                            </td>
                                                          )
                                                        )}
                                                        <td
                                                          style={{
                                                            width: "1%",
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          <i
                                                            className="bx bx-trash"
                                                            style={{
                                                              fontSize: "20px",
                                                              paddingTop: "5px",
                                                              textAlign:
                                                                "center",
                                                              verticalAlign:
                                                                "middle",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              onDeleteFormDonneesComptable(
                                                                rowData.index
                                                              )
                                                            }
                                                          ></i>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                  <tr>
                                                    <td colSpan="9">
                                                      <button
                                                        type="button"
                                                        style={tableaustyles}
                                                        className="btn btn-info mt-3 mt-lg-0"
                                                        onClick={
                                                          onAddFormDonneesComptable
                                                        }
                                                      >
                                                        Ajouter
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </Col>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                              <Col sm="6">
                                {pmeData?.detail_pme?.[
                                  "Prestations externalisées"
                                ] ? (
                                  <>
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En‑tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={togglePrestationsAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Prestations
                                          </span>
                                        </div>
                                        {isPrestationsAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isPrestationsAccordionOpen}
                                      >
                                        <CardBody className="p-2">
                                          <Col sm="12">
                                            <div className="table-responsive">
                                              <table
                                                className="table table-bordered rounded-3 overflow-hidden"
                                                style={{
                                                  borderCollapse: "collapse",
                                                  width: "100%",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    {pmeData?.detail_pme?.[
                                                      "Prestations externalisées"
                                                    ]?.[
                                                      "Prestations"
                                                    ].header.map(
                                                      (columnName, index) => (
                                                        <th
                                                          className="text-nowrap"
                                                          style={tableaustyles}
                                                          key={index}
                                                        >
                                                          {columnName}
                                                        </th>
                                                      )
                                                    )}
                                                    <th
                                                      className="text-nowrap"
                                                      style={{
                                                        background: "#555B21",
                                                        color: "white",
                                                        paddingTop: "5px",
                                                        paddingBottom: "5px",
                                                        width: "1%",
                                                      }}
                                                      key="Del"
                                                    ></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {formPrestation.map(
                                                    (rowData) => (
                                                      <tr key={rowData.index}>
                                                        {Object.entries(
                                                          rowData
                                                        ).map(([key, value]) =>
                                                          key !== "id" &&
                                                          key !== "index" ? (
                                                            <td key={key}>
                                                              {key ===
                                                              "partenaire_id" ? (
                                                                <select
                                                                  value={
                                                                    value?.value
                                                                  }
                                                                  name="partenaire_id"
                                                                  className="form-control form-control-sm"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputPrestationChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                >
                                                                  {renderPartenaireHmfOptions()}
                                                                </select>
                                                              ) : key ===
                                                                "montant" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputPrestationChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                <span>
                                                                  {value}
                                                                </span>
                                                              )}
                                                            </td>
                                                          ) : (
                                                            <td
                                                              className="d-none"
                                                              key={key}
                                                            >
                                                              <input
                                                                type="hidden"
                                                                value={value}
                                                                readOnly
                                                              />
                                                            </td>
                                                          )
                                                        )}
                                                        <td
                                                          style={{
                                                            width: "1%",
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          <i
                                                            className="bx bx-trash"
                                                            style={{
                                                              fontSize: "20px",
                                                              paddingTop: "5px",
                                                              textAlign:
                                                                "center",
                                                              verticalAlign:
                                                                "middle",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              onDeleteFormPrestation(
                                                                rowData.index
                                                              )
                                                            }
                                                          ></i>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                  <tr>
                                                    <td colSpan="9">
                                                      <button
                                                        type="button"
                                                        style={tableaustyles}
                                                        className="btn btn-info mt-3 mt-lg-0"
                                                        onClick={
                                                          onAddFormPrestation
                                                        }
                                                      >
                                                        Ajouter
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </Col>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                              <Col sm="6">
                                {pmeData?.detail_pme?.["Comptabilité"] && (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En‑tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleComptabiliteAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Comptabilité
                                        </span>
                                      </div>
                                      {isComptabiliteAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse
                                      isOpen={isComptabiliteAccordionOpen}
                                    >
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            pmeData?.detail_pme?.[
                                              "Comptabilité"
                                            ]
                                          ).map(([key, value], index) => (
                                            <React.Fragment key={index}>
                                              {key === "Service des impôts" && (
                                                <div
                                                  className="field-item px-2 py-1"
                                                  style={{
                                                    backgroundColor: "white",
                                                    transition:
                                                      "all 0.15s ease",
                                                    borderLeft:
                                                      "3px solid transparent",
                                                    marginBottom: "1px",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }}
                                                >
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          Service des impôts
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedService?.label ==
                                                          null
                                                            ? null
                                                            : selectedService
                                                        }
                                                        onChange={
                                                          handleServiceChange
                                                        }
                                                        options={renderServiceOptions()}
                                                        isClearable={true}
                                                        isSearchable={false}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner un service..."
                                                      />
                                                    </Col>
                                                  </Row>
                                                </div>
                                              )}
                                            </React.Fragment>
                                          ))}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                )}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditImpression;
